//
//
//
//
//
//
//
//
//
//
//

export default{
	props: ["getload"],
	data(){
		return {
			
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/xload.vue